
import React from 'react';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import get from 'lodash/get';

import Tabs from './Tabs';
import TabPanel from './TabPanel';

const TabsPanel = (props) => {

    const classNames = mergeStyleSets({
        TabsPanel: {
            height: '100%',
            ...get(props, 'styles.root', {})
        },
        tabPanel: {
            padding: '0 8px 0 8px'
        }
    });

    const childrenTabPanels = props.children.filter(item => {
        return (item && (item.type === TabPanel));
    });

    const activeTabPanel = childrenTabPanels.reduce((previous, current) => {
        return (current && (current.props.name === props.active))
            ? current
            : previous;
    }, null);

    const onClick = (name) => {
        if (props.setActivePanel) {
            props.setActivePanel(name);
        }
    };

    const tabs = (
        <Stack.Item>
            <Tabs
                active={props.active}
                additionalContent={props.additionalContent}
                onClick={onClick}
            >
                {childrenTabPanels}
            </Tabs>
        </Stack.Item>
    );

    return (
        <Stack horizontal className={classNames.TabsPanel}>
            {(props.tabSide === 'left') && tabs}
            <Stack.Item grow className={classNames.tabPanel}>
                <TabPanel>
                    {activeTabPanel ? activeTabPanel.props.children : null}
                </TabPanel>
            </Stack.Item>
            {(props.tabSide === 'right') && tabs}
        </Stack>
    );
}

export default TabsPanel;
